var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('auth-wrap',{attrs:{"img":_vm.img}},[_c('auth-register',{on:{"changeImage":_vm.changeImage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }